import styled from "styled-components";

export const GridWrapper = styled.div`
    height: 68vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 62vh;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 5px;
        border-right: 1px solid white;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        text-align: center;
        // line-height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #ddd !important;
    }

    .donor-connect-user-case-load {
        line-height: initial;
        display: flex;
        align-items: center;
    }

    .donor-connect-user-case-load > .ag-react-container {
        width: 100%;
    }

    .donor-connect-drop-down {
        display: flex;
        align-items: center;
    }

    .donor-connect-drop-down > .ag-react-container {
        width: 100%;
    }

    .action-menu {
        overflow: visible;
        border-bottom: none;
        //line-height: 28px;
        display: flex;
        align-items: center;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-row {
        background-color: lightgray;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    span.targeted > .dropdown {
        padding: 0px;
    }

    span.targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.active-targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: yellow;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.category > .dropdown > .dropdown-toggle {
        background-color: transparent;
        // color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    .dropdown > .dropdown-toggle {
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    // .dropdown-menu {
    //     font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    // }

    .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
        background-color: #ddd;
    }
`;